/** Formats TileMap properties for the details panel. */
import { formatNode2DProperties } from '../../../base/node2d/propertyFormatter';
export function formatTileMapProperties(properties) {
    const items = [
        { label: 'Tile Set', value: properties.tile_set ?? '(none)' },
        { label: 'Layers', value: properties.layers.length.toString() },
    ];
    for (const layer of properties.layers) {
        const count = layer.cells?.length ?? 0;
        items.push({
            label: layer.name,
            value: layer.cells === null ? 'invalid data' : `${count} cell${count === 1 ? '' : 's'}`,
        });
    }
    return [{ title: 'Tile Map', items }, ...formatNode2DProperties(properties)];
}
//# sourceMappingURL=propertyFormatter.js.map